var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.busy)?_c('b-form-select',{attrs:{"autocomplete":"off","options":_vm.options,"multiple":_vm.element.multiple,"select-size":_vm.element['select-size'],"required":_vm.element.required},on:{"change":_vm.handleInput},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }